import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import NewsList from '../../../../components/newsList';
import ListTitle from '../../../../components/listTitle';

class FinanceBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: {
                financeTopic,
                financeTitle0,
                financeTitle1,
                financeList0,
                financeList1,
                financeList2,
                financeList3,
                financeListAd,
            },
        } = this.props;

        return (
            <div id="financeNewsList" className={styles.finance_box}>
                <Chip id="50062" type="struct" title="财经栏标题" groupName="财经栏" content={financeTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75044"
                    type="recommend"
                    title="财经栏头条1"
                    groupName="财经栏"
                    content={financeTitle0}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75045"
                    type="recommend"
                    title="财经栏新闻列表1"
                    groupName="财经栏"
                    content={financeList0}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
                <Chip
                    id="75046"
                    type="recommend"
                    title="财经栏头条2"
                    groupName="财经栏"
                    content={financeTitle1}
                    translate="handleNewsContentData">
                    <ListTitle />
                </Chip>
                <Chip
                    id="75047"
                    type="recommend"
                    title="财经栏新闻列表2"
                    groupName="财经栏"
                    content={financeList1}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
                <Chip
                    id="75048"
                    type="recommend"
                    title="财经栏新闻列表3"
                    groupName="财经栏"
                    content={financeList2}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
                <Chip
                    id="75049"
                    type="recommend"
                    title="财经栏新闻列表4"
                    groupName="财经栏"
                    content={financeList3}
                    translate="handleNewsContentData">
                    <NewsList isList ad={financeListAd} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(FinanceBox);
